import styled from 'styled-components'
import { THEME } from '../../themes'

export const FooterComponent = styled.div`
  border-top: 2px solid rgba(9, 30, 66, 0.08);
	background-color: ${THEME.COLORS.WHITE};
  color: ${THEME.COLORS.TEXT_GRAY};
	width: 100%;
`
